import React from "react";
import { STATE_LABELS, STATE_CLASSES } from "@/lib/format";

export default function StatusBadge({ stato }) {
  const label = STATE_LABELS[stato] || stato;
  const cls = STATE_CLASSES[stato] || "bg-slate-100 text-slate-700 border-slate-300";
  return (
    <span
      data-testid={`status-badge-${stato}`}
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium ${cls}`}
    >
      {label}
    </span>
  );
}
